import _regeneratorRuntime from "@babel/runtime/regenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import WebSocket from 'ws';
import * as Stream from 'stream';

function request(client, request) {
  return new Promise(function (resolve, reject) {
    var isSettled = false;
    var requestId = "".concat(Date.now(), "::").concat(Math.random());

    var listener = function listener(data) {
      try {
        var message = JSON.parse(data.toString('utf8'));

        if (message.requestId === requestId) {
          if (!isSettled) {
            isSettled = true;
            resolve(message);
          }

          client.off('message', listener);
        }
      } catch (err) {
        if (!isSettled) {
          isSettled = true;
          reject(err);
        }

        client.off('message', listener);
      }
    };

    client.on('message', listener);
    client.send(JSON.stringify(Object.assign({
      requestId: requestId
    }, request)), function (err) {
      if (err && !isSettled) {
        reject(err);
        isSettled = true;
      }
    });
  });
}

export var WebSocketSerialPort =
/*#__PURE__*/
function (_Stream$Duplex) {
  _inherits(WebSocketSerialPort, _Stream$Duplex);

  function WebSocketSerialPort(client, path, baudRate) {
    var _this;

    _classCallCheck(this, WebSocketSerialPort);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WebSocketSerialPort).call(this));
    _this.client = client;
    _this.path = path;
    _this.baudRate = baudRate;
    _this.isOpen = false;
    _this.binding = null;

    _this.responseListener = function (response) {
      if (response.port === _this.path) {
        switch (response.cmd) {
          case 'error':
            _this.emit('error', Error(response.message));

            break;

          case 'data':
            _this.emit('data', Buffer.from(response.data));

            break;

          case 'closed':
            _this.emit('close');

            break;
        }
      }
    };

    return _this;
  }

  _createClass(WebSocketSerialPort, [{
    key: "write",
    value: function write(buffer, encoding, callback) {
      var _this2 = this;

      var data;
      if (Array.isArray(buffer)) data = buffer;else if (typeof buffer === 'string') {
        if (typeof encoding === 'string') {
          buffer = Buffer.from(buffer, encoding);
        } else {
          buffer = Buffer.from(buffer);
        }
      }

      if (Buffer.isBuffer(buffer)) {
        data = buffer.toJSON().data;
      }

      if (!data) throw Error('Unsupported message type');

      if (typeof encoding === 'function') {
        callback = encoding;
      }

      request(this.client, {
        requestId: '',
        cmd: 'write',
        port: this.path,
        data: data
      }).then(function (response) {
        if (response.cmd !== 'success') throw Error('Enexpected response from server');
        if (callback) callback(null, data.length);
      })["catch"](function (err) {
        if (callback) callback(err, 0);else _this2.emit('error', err);
      });
      return false;
    }
  }, {
    key: "open",
    value: function open(callback) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return request(this.client, {
                  requestId: '',
                  cmd: 'open',
                  port: this.path,
                  baudRate: this.baudRate
                });

              case 2:
                response = _context.sent;

                if (!(response.cmd !== 'success')) {
                  _context.next = 5;
                  break;
                }

                throw Error('Unexpected response from server');

              case 5:
                this.client.on('message', this.responseListener);
                this.isOpen = true;
                if (callback) callback();

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "close",
    value: function close(callback) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var response, error;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return request(this.client, {
                  requestId: '',
                  cmd: 'close',
                  port: this.path
                });

              case 2:
                response = _context2.sent;

                if (response.cmd !== 'closed' || response.port !== this.path) {
                  error = Error('Unexpected response from server');
                  if (callback) callback(error);else this.emit('error', error);
                }

                this.client.off('message', this.responseListener);
                this.isOpen = false;
                if (callback) callback();
                this.emit('close');

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "update",
    value: function update() {
      throw Error('unimplemented');
    }
  }, {
    key: "read",
    value: function read() {
      throw Error('unimplemented');
    }
  }, {
    key: "set",
    value: function set() {
      throw Error('unimplemented');
    }
  }, {
    key: "get",
    value: function get() {
      throw Error('unimplemented');
    }
  }, {
    key: "flush",
    value: function flush() {
      throw Error('unimplemented');
    }
  }, {
    key: "drain",
    value: function drain() {
      throw Error('unimplemented');
    }
  }, {
    key: "pause",
    value: function pause() {
      throw Error('unimplemented');
    }
  }, {
    key: "resume",
    value: function resume() {
      throw Error('unimplemented');
    }
  }]);

  return WebSocketSerialPort;
}(Stream.Duplex);
export function createClient(address) {
  var _this3 = this;

  var client = new WebSocket(address, 'serialport-net');
  return {
    listPorts: function listPorts() {
      return __awaiter(_this3, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return request(client, {
                  requestId: '',
                  cmd: 'listDevices'
                });

              case 2:
                response = _context3.sent;

                if (!(response.cmd !== 'listDevices')) {
                  _context3.next = 5;
                  break;
                }

                throw Error('Unexpected response from server');

              case 5:
                return _context3.abrupt("return", response.devices);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));
    },
    openPort: function openPort(port, options) {
      return __awaiter(_this3, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        var serialport;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                serialport = new WebSocketSerialPort(client, port, options.baudRate);

                if (!(options.autoOpen || options.autoOpen === undefined)) {
                  _context4.next = 4;
                  break;
                }

                _context4.next = 4;
                return serialport.open();

              case 4:
                return _context4.abrupt("return", serialport);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }
  };
}

